import initVideos from './videos';

import defaultSettings from './settings';

export default function Vimeo(userSettings) {
  const settings = _.assign({}, defaultSettings, userSettings);

  const videos = initVideos(settings);

  _.assign(this, {
    videos,
  });
}



// WEBPACK FOOTER //
// ./src/transport/adapters/vimeo/index.js